import { chatbotMessageTemplates } from '../chatbot/messageTemplates';
import adminMessages from './admin.messages';
import adminProperties from './admin.properties';
import type {
  Match2BoosterType,
  Match2PowerupType,
} from '../match2/match2.ruleset';

type ProfileProperty = {
  caption: string;
  property: keyof typeof adminProperties | 'profileName' | 'match2Level';
};

const profile: ProfileProperty[] = [
  { caption: 'Name', property: 'profileName' },
  { caption: 'LTV', property: 'adminProfileLtv' },
  { caption: 'Created at', property: 'adminProfileCreatedAt' },
  { caption: 'Updated at', property: 'adminProfileUpdatedAt' },
  { caption: 'Gems (free)', property: 'adminProfileFreeGems' },
  { caption: 'Gems (paid)', property: 'adminProfilePaidGems' },
  { caption: 'B-Coins', property: 'adminProfilePoints' },
  { caption: 'Match2 Level', property: 'match2Level' },
  {
    caption: 'Super Lollipop Streak',
    property: 'adminProfileSuperLollipopStreak',
  },
  { caption: 'Last purchase name', property: 'adminProfileLastPurchaseName' },
  { caption: 'Last purchase date', property: 'adminProfileLastPurchaseDate' },
  { caption: 'Pet Name', property: 'adminPetName' },
  { caption: 'Pet Species', property: 'adminPetSpecies' },
];

const adminMessageGroups: {
  [name: string]: (keyof typeof adminMessages)[];
} = {
  Gems: ['admin_addFreeGems', 'admin_removeGems', 'admin_setFreeGems'],
  Coins: ['admin_addCoins', 'admin_removeCoins', 'admin_setCoins'],
  Pet: ['admin_renamePet'],
  Recovery: ['admin_decorationRecovery'],
  Energy: ['admin_addEnergy', 'admin_removeEnergy', 'admin_setEnergy'],
  Powerups: ['admin_addPowerups', 'admin_removePowerups', 'admin_setPowerups'],
  Boosters: ['admin_addBoosters', 'admin_removeBoosters', 'admin_setBoosters'],
  ExtraMoves: ['admin_addMoves', 'admin_removeMoves', 'admin_setMoves'],
  Multiplier: [
    'admin_addMultiplier',
    'admin_removeMultiplier',
    'admin_setMultiplier',
  ],
  BattlePass: ['admin_grantBattlePass', 'admin_revokeBattlePass'],
  Demographics: ['admin_setAgeRange'],
  SalePacks: ['admin_grantSalePack', 'admin_grantBundleSalePack'],
};

const valueLabels = {
  rocket: 'Firecracker',
  bomb: 'Water Balloon',
  cube: 'Lollipop',
  dart: 'Hammer',
  bullet: 'Airplane',
  drill: 'Cup Rocket',
  roulette: 'Pinwheel',
} satisfies Record<Match2PowerupType | Match2BoosterType, string>;

export default {
  chatbotMessageTemplates,
  profile,
  adminMessageGroups,
  valueLabels,
};
